import { render, staticRenderFns } from "./CommodityCategory.vue?vue&type=template&id=7a6d13b0&scoped=true"
import script from "./CommodityCategory.vue?vue&type=script&lang=js"
export * from "./CommodityCategory.vue?vue&type=script&lang=js"
import style0 from "./CommodityCategory.vue?vue&type=style&index=0&id=7a6d13b0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a6d13b0",
  null
  
)

export default component.exports